import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {delay,  first, take, takeUntil, tap} from "rxjs/operators";
import {
  ACTIVE_REGISTRATION_STATUSES,
  CLIENT_TYPE,
  CLIENT_TYPE_OFWCA,
  CLIENT_TYPE_OFWCA_FROM_OUTSIDE,
  CLIENT_TYPE_PARTNER,
  DICT_TYPE_REGISTRATION_ID_TYPE,
  DICT_TYPE_SUPPORT_STATUS,
  DictService,
  SERVICE_TYPE,
  SERVICE_TYPE_CORPORATION,
  SUPPORT_STATUS_CLOSED,
  SUPPORT_STATUS_DURING,
  TYPE_OF_ACTIVITY_AGENT_TRAINING,
  TYPE_OF_ACTIVITY_CALCULATION_AND_COMPARISON_OF_OFFERS,
  TYPE_OF_ACTIVITY_COMMISSION_EXPLANATION,
  TYPE_OF_ACTIVITY_COMPARE_OFFERS,
  TYPE_OF_ACTIVITY_COMPLETION_OF_DATE,
  TYPE_OF_ACTIVITY_CORPORATION_COMPARE_OFFERS, TYPE_OF_ACTIVITY_CORPORATION_ISSUING_POLICY,
  TYPE_OF_ACTIVITY_CORPORATION_OFFEAR_PREPARATION,
  TYPE_OF_ACTIVITY_CORPORATION_OTHER,
  TYPE_OF_ACTIVITY_CORPORATION_PRODUCT_INQUIRY,
  TYPE_OF_ACTIVITY_CORPORATION_SENDING_PROCESS_GUIDELINES,
  TYPE_OF_ACTIVITY_CORPORATION_SYSTEM_HELP,
  TYPE_OF_ACTIVITY_DISTRIBUTING_SHORTAGES,
  TYPE_OF_ACTIVITY_EXPLANATION_OF_ERRORS,
  TYPE_OF_ACTIVITY_INTERPRETATION_OF_OWU,
  TYPE_OF_ACTIVITY_ISSUING_A_POLICY,
  TYPE_OF_ACTIVITY_NEGOTIATING_COMMISSIONS,
  TYPE_OF_ACTIVITY_NEGOTIATING_WITH_TU,
  TYPE_OF_ACTIVITY_OTHER,
  TYPE_OF_ACTIVITY_PREMIUM_CALCULATION,
  TYPE_OF_ACTIVITY_PRODUCT_INQUIRY,
  TYPE_OF_ACTIVITY_PUBLICATION_OF_PRINTED_MATTER,
  TYPE_OF_ACTIVITY_SALES_OFFICE,
  TYPE_OF_ACTIVITY_SENDING_PROCESS_GUIDELINES_IN_TU,
  TYPE_OF_ACTIVITY_SENDING_PROCESS_INSTRUCTIONS_IN_TU,
  TYPE_OF_ACTIVITY_SERVICE_ASSISTANCE,
  TYPE_OF_ACTIVITY_SETTLEMENT_OF_DOCUMENTS,
  TYPE_OF_ACTIVITY_SHIPPING_PREPARATION,
  TYPE_OF_ACTIVITY_SYSTEM_HELP
} from "../../../shared/services/dict.service";
import {Observable, of, ReplaySubject} from "rxjs";
import {Contract} from "../../../shared/interface/contract";
import {RegistrationService} from "../../../shared/services/registration.service";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {
  IC_ALLIANZ,
  IC_COLONNADE,
  IC_COMPENSA,
  IC_ERGO_HESTIA,
  IC_EUROPA,
  IC_GENERALI, IC_LLOYDS_LIFE, IC_POCZTOWE_TUW,
  IC_PZU,
  IC_RESO,
  IC_SIGNAL_IDUNA,
  IC_TUW_TUW,
  IC_TUZ_UBEZPIECZENIA,
  IC_UNIQA,
  IC_UNIQA_INTERRISK,
  IC_WARTA,
  IC_WIENER,
  InsuranceCompanyService
} from "../../../shared/services/insurance-company.service";
import {Registration} from "../../../shared/interface/registration";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Dictionary} from "../../../shared/interface/dictionary";
import {RegistrationIdentifier} from "../../../shared/interface/registration-identifier";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Support} from "../../../shared/interface/support";
import {INSURANCE_TYPE_ASSETS, INSURANCE_TYPE_LIFE} from '../../../shared/services/dict.service';
import {CorporationService} from "../../../shared/services/corporation.service";


@Component({
  selector: 'app-corporation-add',
  templateUrl: './corporation-add.component.html',
  styleUrls: ['./corporation-add.component.scss']
})
export class CorporationAddComponent implements OnInit {


  @Input() supportObject?: Support;
  @Input() serviceTypeKeys?: string = null;
  @Input() support?: Observable<Support>;
  @Output() closeModification = new EventEmitter<any>();

  readonly INSURANCE_TYPE_LIFE = INSURANCE_TYPE_LIFE;
  readonly INSURANCE_TYPE_ASSETS = INSURANCE_TYPE_ASSETS;
  readonly ACTIVE_STATUSES = ACTIVE_REGISTRATION_STATUSES;

  supportForm: FormGroup;
  clientTypeControl: FormControl;
  typeOfReportControl: FormControl;
  typeOfActivityControl: FormControl;
  searchControl: FormControl;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  noteControl: FormControl;
  insuranceCompanysControl: FormControl;
  statusControl: FormControl;
  reportingPersonOfwca = false;
  ofwcaRegistrationActive = true;
  reportingPersonPartner = false;
  ofwcaRegistrationActiveControl: FormControl;
  ofwcaContracts: Contract[] = [];
  partnerContracts: Contract[] = [];
  partnerOfwca: Ofwca[] = [];
  ofwcaRegistrations: Registration[] = [];
  timeControl: FormControl;
  startTime: number = null;
  typeOfActivityOfwca = false;
  typeOfActivityGeneral = false;
  displayedColumnsContact: string[] = ['number', 'type', 'status', 'concludeDate', 'owner', 'party',
    'activeTo', 'assetsRegional', 'company'];
  displayedColumnsRegistrationsOfwca: string[] = ['insureCompany', 'status', 'company', 'partner', 'login'];
  displayedColumnsOfwcaPartner: string[] = ['box', 'fullName', 'status', 'assetsRegional'];
  insuranceCompanies: InsuranceCompany[] = [];
  insuranceCompaniesLife: InsuranceCompany[] = [];
  insuranceCompaniesAssets: InsuranceCompany[] = [];
  selectedInsuranceCompanies =  [];
  selectedOfwca: Ofwca = null;
  registrationIdTypes: {[id: string]: Dictionary} = {};
  registrationIdentifiers: {[uuid: string]: RegistrationIdentifier} = {};
  completedLife = false;
  completedAssets = false;
  lifeRisk: FormControl;
  propertyRisk: FormControl;
  customerDataControl: FormControl;
  concludedPolicyControl: FormControl;
  policyNumberControl: FormControl;
  serviceTypeControl: FormControl;
  serviceTypeCorporation  = false;
  reasonForRefusalControl: FormControl;
  policyTypeControl: FormControl;
  annotationControl: FormControl;
  policyEndAtControl: FormControl;
  companyControl: FormControl;
  productTypeControl: FormControl;
  refusalReasonControl: FormControl;
  save = true;
  note: string ;
  insuranceCompanyKeys = [
    IC_PZU, IC_ERGO_HESTIA, IC_WARTA, IC_UNIQA, IC_UNIQA_INTERRISK, IC_WIENER, IC_SIGNAL_IDUNA,
    IC_COLONNADE, IC_RESO, IC_TUZ_UBEZPIECZENIA, IC_ALLIANZ, IC_EUROPA, IC_COMPENSA,
    IC_GENERALI, IC_TUW_TUW, IC_POCZTOWE_TUW, IC_LLOYDS_LIFE
  ];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private dictService: DictService,
    private corporationService: CorporationService,
    private insuranceCompanyService: InsuranceCompanyService,
    private registrationService: RegistrationService,
    private snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
  ) {
    this.supportForm = fb.group({
      clientType: this.clientTypeControl = fb.control('', [Validators.required]),
      typeOfReport: this.typeOfReportControl = fb.control('', [Validators.required]),
      typeOfActivity: this.typeOfActivityControl = fb.control('', [Validators.required]),
      ofwca: this.ofwcaControl = fb.control(''),
      partner: this.partnerControl = fb.control(''),
      note: this.noteControl = fb.control(''),
      time: this.timeControl = fb.control(0),
      insuranceCompanys: this.insuranceCompanysControl = this.fb.control(''),
      status: this.statusControl = this.fb.control(''),
      ofwcaRegistrationActive: this.ofwcaRegistrationActiveControl = this.fb.control(true),
      lifeRisk: this.lifeRisk = fb.control([]),
      propertyRisk: this.propertyRisk = fb.control([]),
      customerData: this.customerDataControl = fb.control(''),
      concludedPolicy: this.concludedPolicyControl = fb.control(''),
      policyNumber: this.policyNumberControl = fb.control(''),
      lifeQuantity:  fb.control(0),
      assetsQuantity: fb.control(0),
      search: this.searchControl = fb.control(''),
      serviceType: this.serviceTypeControl = fb.control('',[Validators.required]),
      reasonForRefusal : this.reasonForRefusalControl = fb.control(''),
      policyType : this.policyTypeControl = fb.control(''),
      annotation : this.annotationControl = fb.control('',[
        Validators.pattern(/^\d+(\.\d{0,2})?$/)
      ]),
      policyEndAt : this.policyEndAtControl = fb.control(''),
      company : this.companyControl = fb.control(''),
      productType : this.productTypeControl = fb.control(''),
      refusalReason : this.refusalReasonControl = fb.control(''),
    });
    this.note = '';
    insuranceCompanyService.getAllInsuranceCompanies()
      .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
        this.insuranceCompanies = result.items;
        this.loadAssetsInsuranceCompanies();
        this.loadLifeInsuranceCompanies();
      });
    this.save = false;
  }

  private loadAssetsInsuranceCompanies(): void {
    if (!this.serviceTypeCorporation) {
      this.insuranceCompaniesAssets = this.insuranceCompanies.filter((insuranceCompany: InsuranceCompany) => {
        return insuranceCompany.type.key === INSURANCE_TYPE_ASSETS
          ;
      });
    } else {
      this.insuranceCompaniesAssets = this.insuranceCompanies.filter((insuranceCompany: InsuranceCompany) => {
        return insuranceCompany.type.key === INSURANCE_TYPE_ASSETS
          &&  this.insuranceCompanyKeys.includes(insuranceCompany.key)
          ;
      });
    }
  }

  private loadLifeInsuranceCompanies(): void {
    this.insuranceCompaniesLife = this.insuranceCompanies.filter((insuranceCompany: InsuranceCompany) => {
      return insuranceCompany.type.key === INSURANCE_TYPE_LIFE
        ;
    });
  }
  ngOnInit(): void {
    this.startTime = new Date().getTime();
    this.dictService.get(SUPPORT_STATUS_DURING, DICT_TYPE_SUPPORT_STATUS)
      .subscribe((dict: Dictionary) => {
        this.statusControl.setValue(dict.id);
      });

    if (this.support) {
      this.support
        .pipe(takeUntil(this.destroyed$))
        .subscribe((support: Support) => {
          this.supportObject = support;
          this.initialize(support);
        });
    }

    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.serviceTypeKeys = this.serviceTypeKeys ?? data.serviceTypeKeys ?? null;
        this.dictService.getId(this.serviceTypeKeys, SERVICE_TYPE)
          .subscribe((dictId: number) => {
            this.serviceTypeControl.setValue(dictId);
          });

        this.serviceTypeCorporation = this.serviceTypeKeys === SERVICE_TYPE_CORPORATION;

      });

    this.loadIdDict();

    this.searchControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(val => {
      let dict;
      if (val !== null && Array.isArray(val) ) {
        if (val[1] === true) {
          this.dictService.getId(CLIENT_TYPE_PARTNER, CLIENT_TYPE)
            .subscribe((dictId: number) => {
              dict = dictId;
            });
          this.partnerControl.setValue(val[0]);
        } else if (val[2] === true) {
          this.dictService.getId(CLIENT_TYPE_OFWCA, CLIENT_TYPE)
            .subscribe((dictId: number) => {
              dict = dictId;
            });
          this.ofwcaControl.setValue(val[0]);
        } else {
          this.dictService.getId(CLIENT_TYPE_OFWCA_FROM_OUTSIDE, CLIENT_TYPE)
            .subscribe((dictId: number) => {
              dict = dictId;
            });
        }
        this.clientTypeControl.setValue(dict);
        this.searchControl.reset();
      }
    });

    this.clientTypeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(val => {
      this.dictService.getKey(val)
        .subscribe((key: string) => {
          if (key === CLIENT_TYPE_OFWCA) {
            this.reportingPersonOfwca = true;
            this.reportingPersonPartner = false;
            this.ofwcaControl.setValidators([Validators.required]);
            this.ofwcaControl.enable();
            this.partnerControl.reset();
            this.partnerControl.setValidators([]);
            this.partnerControl.disable();
          } else if (key === CLIENT_TYPE_PARTNER) {
            if (!this.supportObject?.ofwca) {
              this.reportingPersonOfwca = false;
              this.ofwcaControl.reset();
            }
            this.reportingPersonPartner = true;
            this.ofwcaControl.setValidators([]);
            this.ofwcaControl.disable();
            this.partnerControl.setValidators([Validators.required]);
            this.partnerControl.enable();
          }else {
            this.reportingPersonOfwca = false;
            this.reportingPersonPartner = false;
            this.ofwcaControl.setValidators([]);
            this.ofwcaControl.disable();
            this.partnerControl.setValidators([]);
            this.partnerControl.disable();
          }
        });
    });
    this.ofwcaRegistrationActiveControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (this.ofwcaRegistrationActiveControl.value){
          this.ofwcaRegistrationActive = true;
        }
      });
    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((ofwcaId: string) => {
        this.ofwcaContracts = [];
        this.ofwcaRegistrations = [];
        if (!this.support) {
          this.typeOfActivityControl.reset();
        } else {
          this.ofwcaRegistrationActive = false;
        }
        if (ofwcaId !== '' && ofwcaId !== null) {
          this.corporationService.getOfwcaContract(ofwcaId)
            .subscribe((contracts: ListResponse<Contract>) => {
              contracts.items.forEach((contract: Contract) => {
                this.ofwcaContracts.push(contract);
              });
            });
          this.corporationService.getOfwcaRegistrations(ofwcaId)
            .subscribe((registrations: ListResponse<Registration>) => {
              if (registrations.total > 0) {
                this.ofwcaRegistrations = [];
                registrations.items.forEach((registration: Registration) => {
                  this.ofwcaRegistrations.push(registration);
                  this.loadIds(registration.uuid);
                });
              }
            });
        }
      });
    this.partnerControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((partnerId: string) => {
        this.partnerContracts = [];
        this.partnerOfwca = [];
        if (!this.support) {
          // this.ofwcaControl.reset();
          this.typeOfActivityControl.reset();
        }
        if (partnerId !== '' &&  partnerId !== null) {
          this.corporationService.getPartnerContract(partnerId)
            .subscribe((contracts: ListResponse<Contract>) => {
              contracts.items.forEach((contract: Contract) => {
                this.partnerContracts.push(contract);
              });
            });
          this.corporationService.getPartnerOfwca(partnerId)
            .subscribe((Ofwcas: ListResponse<Ofwca>) => {
              if (Ofwcas.total > 0) {
                Ofwcas.items.forEach((ofwca: Ofwca) => {
                  this.partnerOfwca.push(ofwca);
                });
              }
            });
        }
      });
    this.typeOfActivityControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(val => {
      this.dictService.getKey(val)
        .subscribe((key: string) => {
          if (key === TYPE_OF_ACTIVITY_PREMIUM_CALCULATION || key === TYPE_OF_ACTIVITY_ISSUING_A_POLICY ||
            key === TYPE_OF_ACTIVITY_CALCULATION_AND_COMPARISON_OF_OFFERS || key ===  TYPE_OF_ACTIVITY_COMPARE_OFFERS ||
            key ===   TYPE_OF_ACTIVITY_SERVICE_ASSISTANCE || key ===  TYPE_OF_ACTIVITY_COMMISSION_EXPLANATION ||
            key === TYPE_OF_ACTIVITY_NEGOTIATING_COMMISSIONS || key ===  TYPE_OF_ACTIVITY_NEGOTIATING_WITH_TU ||
            key ===   TYPE_OF_ACTIVITY_INTERPRETATION_OF_OWU || key ===  TYPE_OF_ACTIVITY_OTHER ||
            key ===  TYPE_OF_ACTIVITY_SYSTEM_HELP || key ===  TYPE_OF_ACTIVITY_SHIPPING_PREPARATION ||
            key ===  TYPE_OF_ACTIVITY_SETTLEMENT_OF_DOCUMENTS || key ===  TYPE_OF_ACTIVITY_DISTRIBUTING_SHORTAGES ||
            key ===  TYPE_OF_ACTIVITY_AGENT_TRAINING || key ===  TYPE_OF_ACTIVITY_EXPLANATION_OF_ERRORS ||
            key ===  TYPE_OF_ACTIVITY_PRODUCT_INQUIRY || key ===  TYPE_OF_ACTIVITY_PUBLICATION_OF_PRINTED_MATTER ||
            key ===  TYPE_OF_ACTIVITY_SALES_OFFICE || key ===  TYPE_OF_ACTIVITY_SENDING_PROCESS_GUIDELINES_IN_TU ||
            key ===  TYPE_OF_ACTIVITY_SENDING_PROCESS_INSTRUCTIONS_IN_TU || key ===  TYPE_OF_ACTIVITY_COMPLETION_OF_DATE ||
            key === TYPE_OF_ACTIVITY_CORPORATION_OFFEAR_PREPARATION || key === TYPE_OF_ACTIVITY_CORPORATION_COMPARE_OFFERS ||
            key === TYPE_OF_ACTIVITY_CORPORATION_OTHER || key === TYPE_OF_ACTIVITY_CORPORATION_SYSTEM_HELP ||
            key === TYPE_OF_ACTIVITY_CORPORATION_SENDING_PROCESS_GUIDELINES || key === TYPE_OF_ACTIVITY_CORPORATION_PRODUCT_INQUIRY ||
            key === TYPE_OF_ACTIVITY_CORPORATION_ISSUING_POLICY )
          {
            this.typeOfActivityOfwca = true;
            this.typeOfActivityGeneral = true;
          } else{
            this.typeOfActivityOfwca = false;
            this.typeOfActivityGeneral = false;
            this.productTypeControl.reset();
            this.reasonForRefusalControl.reset();
            this.concludedPolicyControl.reset();
            this.refusalReasonControl.reset();
            this.policyNumberControl.reset();
            this.companyControl.reset();
            this.policyTypeControl.reset();
            this.annotationControl.reset();
            this.concludedPolicyControl.reset();
            this.selectedInsuranceCompanies = [];
          }
        });
    });
    this.concludedPolicyControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(val => {
      if (val === false){
        this.policyNumberControl.disable();
      } else {
        this.policyNumberControl.enable();
      }
    });
  }

  initialize(support: Support): void {
    of(support)
      .pipe(
        delay(0),
        tap(() => {
          this.selectedInsuranceCompanies = support.insuranceCompanys;
          this.ofwcaRegistrationActive = false;
          if (support.ofwca && support.partner){
            this.addOfwca(support.ofwca);
          }
          this.supportForm.reset({
            clientType: support.clientType?.id,
            typeOfReport: support.typeOfReport?.id,
            typeOfActivity: support.typeOfActivity?.id,
            ofwca: support.ofwca?.uuid,
            partner: support.partner?.uuid,
            time: support.time,
            insuranceCompanys: support.insuranceCompanys,
            status: support.status?.id,
            lifeRisk: support.lifeRisk.map((tag: Dictionary) => tag.id),
            propertyRisk: support.propertyRisk.map((tag: Dictionary) => tag.id),
            customerData: support.customerData,
            concludedPolicy: support.concludedPolicy,
            policyNumber: support.policyNumber,
            lifeQuantity:  support.lifeQuantity,
            assetsQuantity: support.assetsQuantity,
            serviceType: support.serviceType?.id,
            reasonForRefusal : support.reasonForRefusal,
            policyType : support.policyType?.id,
            annotation: support.annotation,
            policyEndAt: support.policyEndAt,
            company : support.company?.id,
            productType : support.productType?.id,
            refusalReason: support.refusalReason?.id,
          });
          this.note = support.note;
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();

    this.serviceTypeCorporation = this.serviceTypeKeys === SERVICE_TYPE_CORPORATION;
  }
  cancel(): void {
    if (!this.supportObject) {
      this.router.navigate(['/korporacja']);
    } else {
      this.closeModification.emit();
    }
  }
  isSelect(row?: string): boolean {
    let isSelect = false;
    this.selectedInsuranceCompanies.forEach((h: string) => {
      if (row === h){
        isSelect = true;
      }
    });
    return isSelect;
  }


  addAssets(header: InsuranceCompany): void{
    if (this.selectedInsuranceCompanies.indexOf(header.name) === -1) {
      this.selectedInsuranceCompanies.push(header.name);
      this.supportForm.get('assetsQuantity').setValue(this.supportForm.get('assetsQuantity').value + 1);
    }else{
      this.selectedInsuranceCompanies.splice(this.selectedInsuranceCompanies.indexOf(header.name),1);
      this.supportForm.get('assetsQuantity').setValue(this.supportForm.get('assetsQuantity').value - 1);
    }
    if (this.supportForm.get('assetsQuantity').value > 0){
      this.propertyRisk.enable();
    }else{
      this.propertyRisk.disable();
      this.propertyRisk.reset();
    }
  }

  loadIdDict(): void {
    this.dictService.getDictSubject()
      .pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.forEach((dict: Dictionary) => {
          if (
            dict.type === DICT_TYPE_REGISTRATION_ID_TYPE
          ) {
            this.registrationIdTypes[dict.id.toString()] = dict;
          }
        });
      });
  }
  loadIds(uuid: string): void {
    this.registrationService.getRegistrationIdsSupport(uuid)
      .pipe(first())
      .subscribe((response: ListResponse<RegistrationIdentifier>) => {
        response.items.forEach((identifier: RegistrationIdentifier) => {
          this.registrationIdentifiers[uuid + identifier.type.id.toString()] = identifier;
        });
      });
  }

  isSelectOfwca(row?: Ofwca): boolean {
    let isSelect = false;
    if (row.uuid === this.selectedOfwca?.uuid){
      isSelect = true;
    }
    return isSelect;
  }
  addOfwca(header: Ofwca): void{
    if (header !== this.selectedOfwca) {
      this.selectedOfwca = header;
      this.ofwcaControl.setValue(header.uuid);
      this.reportingPersonOfwca = true;
    }else{
      this.selectedOfwca = null;
      this.ofwcaControl.setValue(null);
      this.reportingPersonOfwca = false;
    }
  }

  sendAndClose(): void{
    this.dictService.get(SUPPORT_STATUS_CLOSED, DICT_TYPE_SUPPORT_STATUS)
      .subscribe((dict: Dictionary) => {
        this.statusControl.setValue(dict.id);
      });
    this.sendForm();
  }
  sendForm(): void {
    this.save = true;

    this.insuranceCompanysControl.setValue(this.selectedInsuranceCompanies.toString());
    let end = new Date().getTime();
    this.timeControl.setValue(Math.round(this.timeControl.value + Math.abs(end - this.startTime)/1000));
    if (!this.supportForm.valid) {
      this.supportForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      this.save = false;
      return;
    }

    let data = new Date();
    if (this.noteControl.value ) {
      this.noteControl.setValue(this.note + '<br> ' +
        '' + this.noteControl.value + ' (  ' + data.toLocaleString() + ' )  ');
    } else {
      this.noteControl.setValue(this.note);
    }

    this.corporationService.sendForm(this.supportForm.getRawValue(), this.supportObject?.uuid )
      .pipe(take(1))
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.supportObject ? 'Pomyślnie zaktualizowano obiekt ' : 'Pomyślnie utworzono obiekt ', '', {
          duration: 2000,
        });
        if (!this.supportObject) {
          this.router.navigate(['/korporacja/szczegoly', response.uuid]);
        } else {
          this.closeModification.emit();
        }
      }, (error: HttpErrorResponse) => {

        this.snackBar.open('Podczas tworzenia obiektu  wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        this.save = false;

      })
    ;
  }

  setAllAssets(completed: boolean) {
    this.completedAssets = completed;
    if (this.completedAssets === true) {
      this.insuranceCompaniesAssets.forEach((insuranceCompany: InsuranceCompany) => {
        if (this.selectedInsuranceCompanies.indexOf(insuranceCompany.name) === -1) {
          this.selectedInsuranceCompanies.push(insuranceCompany.name);
          this.supportForm.get('assetsQuantity').setValue(this.supportForm.get('assetsQuantity').value + 1);
        }
      });
    }else{
      this.insuranceCompaniesAssets.forEach((insuranceCompany: InsuranceCompany) => {
        this.selectedInsuranceCompanies.splice(this.selectedInsuranceCompanies.indexOf(insuranceCompany.name),1);
        this.supportForm.get('assetsQuantity').setValue(this.supportForm.get('assetsQuantity').value - 1);
      });
      this.supportForm.get('assetsQuantity').setValue(0);

    }
    if (this.supportForm.get('assetsQuantity').value > 0){
      this.propertyRisk.enable();
    }else{
      this.propertyRisk.disable();
      this.propertyRisk.reset();
    }
  }
}
